import { useSearchParams } from 'react-router'
import api from '../../api'
import { Project, Provider, ProviderMeta } from '../../types'
import Alert from '../../ui/Alert'
import Button from '../../ui/Button'
import { useTranslation } from 'react-i18next'

interface SlackOAuthSetupProps {
    project: Project
    provider?: Provider
    meta: ProviderMeta
    onChange: (provider: Provider) => void
}

export default function SlackOAuthSetup({ project, provider }: SlackOAuthSetupProps) {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()
    const slackSuccess = searchParams.get('slack_success')
    const slackError = searchParams.get('slack_error')

    const handleConnect = async () => {
        const response = await api.slack.getOAuthUrl(project.id)
        window.location.href = response.url
    }

    return (
        <div>
            {slackError && <Alert variant="error" title={t('error')}>
                {`Failed to connect Slack: ${slackError}`}
            </Alert>}
            {slackSuccess && <Alert variant="success" title={t('success')}>
                Slack connected successfully!
            </Alert>}

            {provider?.id
                ? <>
                    <Alert variant="plain" title="Slack">
                        {`Connected to workspace: ${provider.data?.team_name ?? provider.name}`}
                    </Alert>
                    <div style={{ marginTop: '16px' }}>
                        <Button variant="secondary" onClick={handleConnect}>
                            Reconnect
                        </Button>
                    </div>
                </>
                : <>
                    <Alert variant="plain" title="Slack">
                        Connect your Slack workspace to enable launch approvals via Slack DMs and link previews for Postles URLs.
                    </Alert>
                    <div style={{ marginTop: '16px' }}>
                        <Button onClick={handleConnect}>
                            Add to Slack
                        </Button>
                    </div>
                </>
            }
        </div>
    )
}
